import { PropsWithChildren } from 'react';

import { RoundButtonType } from './types';

import * as S from './styled';

const RoundButton = ({
    onClick,
    size = 44,
    children,
    disabled = false,
    dataTestId,
    dataLocator = 'roundButton',
}: PropsWithChildren<RoundButtonType>) => {
    return (
        <S.Button
            type="button"
            onClick={onClick}
            size={size}
            disabled={disabled}
            data-testid={dataTestId}
            data-locator={dataLocator}
        >
            {children}
        </S.Button>
    );
};

export default RoundButton;
